import styled from "styled-components"
import { Colors, H4 } from 'styles/app-styles'
import { InputBaseStyles } from 'styles/input-styles'
import DateText from 'components/inputs/date-text';
import DataTable_s from 'components/table/data-table-styles'

export const DateText_s = styled(DateText)`
  ${InputBaseStyles}
  padding: 0 8px;
  outline: none;
  width: 155px;
`

export const ReportContainer_s = styled.div`
  border: 1px solid ${Colors.towerGrey};
  display: grid;
  grid-template-columns: 250px auto;
  grid-template-rows: 1fr;
  grid-template-areas:
    "reports form";
  height: calc(100vh - 120px);
  margin: 15px;
  margin-top: -20px;

  ${DataTable_s}{
    svg {
      height: 16px;
      margin: 0px 5px;
      vertical-align: middle;
      .r-svg { fill: ${Colors.blackPearl}; }
    }
    th.p-filter-column .p-checkbox {
      border: 1px solid ${Colors.towerGrey};
      border-radius: 2px;
      height: 18px;
      margin-left: 3px;
      width: 18px;
    }
  }
`

export const ReportContainerStandalone_s = styled.div`
  height: calc(100vh - 120px);
  margin: 15px;

  [data-qa="report-property-grid-s"] {
    max-height: 49vh;
    overflow-y: scroll;
  }

  ${DataTable_s}{
    svg {
      height: 16px;
      margin: 0px 5px;
      vertical-align: middle;
      .r-svg { fill: ${Colors.blackPearl}; }
    }
    th.p-filter-column .p-checkbox {
      border: 1px solid ${Colors.towerGrey};
      border-radius: 2px;
      height: 18px;
      margin-left: 3px;
      width: 18px;
    }
  }
`

export const ReportForms_s = styled.div`
  grid-area: form;
  margin: 15px;

  > div:first-child {
    margin-bottom: 15px;
  }

  .p-paginator {
    position: relative;
  }
`

export const ReportForm_s = styled.div`
  align-items: start;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  > div {
    display: flex;
    flex-direction: column;
    margin: 0 15px 15px 0;
    label {
      margin-bottom: 5px;
    }
  }
`

export const ReportSelection_s = styled.div`
  border-right: 1px solid ${Colors.towerGrey};
  grid-area: reports;
  ${H4}{
    font-size: 16px;
    margin: 15px;
  }
  ul {
    background: ${Colors.inputFocus};
    margin-top: 10px;
    list-style: none;
    padding-left: 0;

    summary {
      border-top: 1px solid ${Colors.towerGrey};
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      padding: 4px 8px 4px 15px;
    }

    svg {
      height: 16px;
      width: 16px;
      .r-svg, .cls-1 {
        fill: ${Colors.blackPearl};
      }
    }
  }
  summary.property-comparison-summary svg:nth-child(2) {
    height: 12px;
    margin: 3px -25px;
    width: 12px;
  }
`

interface ReportOptionProps {
  active: boolean
}

export const ReportSelectionItem_s = styled.li<ReportOptionProps>`
  background: ${props => props.active ? `${Colors.heatherGrey}` : '#FAFCFE'};
  border-bottom: 1px solid ${Colors.towerGrey};
  cursor: pointer;
  font-size: 14px;
  font-weight: ${props => props.active ? '500' : '300'};
  height: 22px;
  line-height: 22px;
  padding: 0 15px;
  &:first-child {
    border-top: 1px solid ${Colors.towerGrey};
  }
  &:hover {
    background: ${Colors.heatherGrey};
  }
`